var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_list",
    clipPath: "url(#clip0_1315_22815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Active Indicator",
    y: 0.5,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F5E6F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6667 29H21.3333C22.0667 29 22.6667 28.4 22.6667 27.6667C22.6667 26.9333 22.0667 26.3333 21.3333 26.3333H18.6667C17.9333 26.3333 17.3333 26.9333 17.3333 27.6667C17.3333 28.4 17.9333 29 18.6667 29ZM8 14.3333C8 15.0667 8.6 15.6667 9.33333 15.6667H30.6667C31.4 15.6667 32 15.0667 32 14.3333C32 13.6 31.4 13 30.6667 13H9.33333C8.6 13 8 13.6 8 14.3333ZM13.3333 22.3333H26.6667C27.4 22.3333 28 21.7333 28 21C28 20.2667 27.4 19.6667 26.6667 19.6667H13.3333C12.6 19.6667 12 20.2667 12 21C12 21.7333 12.6 22.3333 13.3333 22.3333Z",
    fill: "#91278F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1315_22815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterList);
export default __webpack_public_path__ + "static/media/filter_list.e693725414e438c2a1e71695f0ec8520.svg";
export { ForwardRef as ReactComponent };